/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Patchy_Raw_Giraffe_ExploreInputs */

const fr_patchy_raw_giraffe_explore = /** @type {(inputs: Patchy_Raw_Giraffe_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment charger`)
};

/**

* @param {Patchy_Raw_Giraffe_ExploreInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const patchy_raw_giraffe_explore = /** @type {((inputs?: Patchy_Raw_Giraffe_ExploreInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Patchy_Raw_Giraffe_ExploreInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_patchy_raw_giraffe_explore(inputs)
});